import "core-js/modules/es.array.push.js";
/* eslint-disable */
import Socket from "@/assets/js/websocket.js";
import Bus from "@/assets/js/bus.js";
import $store from "@/store/index.js";
import axios from 'axios';
import i18n from '@/lang';
import Router from '@/router';
const moment = require('moment');

// AWS region for every Drive (/file/*) call — upload and query alike.
// Pinned to us-east-1 on purpose: it used to be geolocated from the client IP
// via GET /partyline-backend/user/region and cached in localStorage forever, so
// the same account ended up with a per-browser region and a split image library
// (files uploaded under one region are invisible to a browser resolved to
// another). Region no longer follows the client IP.
export const S3_REGION = 'us-east-1';
const isDark = useDark();
if (handleLocalStorage('get', 'theme')) {
  localStorage.getItem('theme') === 'dark' ? isDark.value = true : isDark.value = false;
} else {
  isDark.value = true;
}
export function getTheme() {
  return {
    isDark
  };
}
export function setTheme(val) {
  val === 'dark' ? isDark.value = true : isDark.value = false;
  const support = handleLocalStorage('set', 'theme', val);
  if (!support) return;
  if (val == 'dark') {
    document.body.style.backgroundColor = '#28282e';
  } else {
    document.body.style.backgroundColor = '#fff';
  }
}
export function isFunction(func) {
  return typeof func === 'function' || Object.prototype.toString.call(func) === '[object Function]';
}
function spaceControl(e) {
  if (e.keyCode === 32) {
    $store.state.spaceBarControl = !$store.state.spaceBarControl;
  }
}
// 添加对空格键的按键监听
const spaceListener = function () {
  document.removeEventListener('keyup', spaceControl);
  document.addEventListener('keyup', spaceControl);
};

//返回32位随机数
const return32Str = function (length = 22) {
  var chars = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z", "a", "b", "c", "d", "e", "f", "g", "h", "i", "j", "k", "l", "m", "n", "o", "p", "q", "r", "s", "t", "u", "v", "w", "x", "y", "z"];
  var num = "";
  for (var i = 0; i < length; i++) {
    let id = parseInt(Math.random() * 61);
    num += chars[id];
  }
  return 'Partyline_' + num;
};
function message(event) {
  let module = "";
  let result = {};
  let origin = '';
  if (typeof event === "object") {
    module = event.module;
    result = event.result;
    origin = event.origin;
  } else {
    module = JSON.parse(event).module;
    result = JSON.parse(event).result;
    origin = JSON.parse(event).origin;
  }
  switch (module) {
    case "flipVideo":
      Bus.$emit("flipVideo", result);
      break;
    case "listCurrentDevice":
      Bus.$emit("refreshSourceStatus", result);
      break;
    case "setCrew":
      Bus.$emit("setCrew", result);
      break;
    case "cancelCrew":
      Bus.$emit("cancelCrew", result);
      break;
    case "startPrivateConversation":
      Bus.$emit("startPrivateConversation", result);
      break;
    case "cancelPrivateConversation":
      Bus.$emit("cancelPrivateConversation", {
        origin,
        ...result
      });
      break;
    case "setUserKkvs":
      Bus.$emit('setUserKkvs', result);
      break;
    case "shareScreen":
      Bus.$emit("shareScreen", result);
      break;
    case "cancelShareScreen":
      Bus.$emit("cancelScreen", result);
      break;
    case "setOutput":
      Bus.$emit("setOutput", result);
      break;
    case "cancelOutput":
      Bus.$emit("cancelOutput", result);
      break;
    case "removeParticipant":
      Bus.$emit("removeParticipant", result);
      break;
    case "switchParty":
      Bus.$emit("switchParty", result);
      break;
    case "groupRtilCodes":
      Bus.$emit("groupRtilCodes", result);
      break;
    case "setBehaviors":
      Bus.$emit("setBehaviors", result);
      break;
    case "endParty":
      Bus.$emit("endParty", result);
      break;
    case "netStatus":
      Bus.$emit("netStatus", result);
      break;
    case "raiseHand":
      Bus.$emit("raiseHand", result);
      break;
    case "denyRaiseHand":
      Bus.$emit("denyRaiseHand", result);
      break;
    case "videoQuality":
      Bus.$emit("videoQuality", result);
      break;
    case "setSpeaker":
      Bus.$emit("setSpeaker", result);
      break;
    case "cancelSpeaker":
      Bus.$emit("cancelSpeaker", result);
      break;
    case "setQuestioner":
      Bus.$emit("setQuestioner", result);
      break;
    case "cancelQuestioner":
      Bus.$emit("cancelQuestioner", result);
      break;
    case "setQuestionSpeaker":
      Bus.$emit("setQuestionSpeaker", result);
      break;
    case "cancelQuestionSpeaker":
      Bus.$emit("cancelQuestionSpeaker", result);
      break;
    case "online":
      Bus.$emit("online", result);
      break;
    case "offline":
      Bus.$emit("offline", result);
      break;
    case "setPartyTitle":
      Bus.$emit("setPartyTitle", result);
      break;
    case "rejoin":
      Bus.$emit("rejoin", result);
      break;
    case "setNoSubscribeRtil":
      Bus.$emit("setNoSubscribeRtil", result);
      break;
    case "questionerList":
      Bus.$emit("questionerList", result);
      break;
    case "changeLayout":
      Bus.$emit("changeLayout", result);
      break;
    case "notify":
      Bus.$emit("notify", result);
      break;
    case "managerOnline":
      Bus.$emit("managerOnline", result);
      break;
    case "rtilLiveStatus":
      Bus.$emit("rtilLiveStatus", result);
      break;
    case "showSlotText":
      Bus.$emit("showSlotText", result);
      break;
    case "cancelShowSlotText":
      Bus.$emit("cancelShowSlotText", result);
      break;
    case "slotChange":
      Bus.$emit("slotChange", result);
      break;
    case "sectionSlotNum":
      Bus.$emit("sectionSlotNum", result);
      break;
    case "unlock":
      Bus.$emit("unlock", result);
      break;
    case "bindCohost":
      Bus.$emit("bindCohost", result);
      break;
    case "cancelPreview":
      Bus.$emit("cancelPreview", result);
      break;
    case "startAudioMix":
      Bus.$emit('startAudioMix', result);
      break;
    case "stopAudioMix":
      Bus.$emit('stopAudioMix', result);
      break;
    case "lockName":
      Bus.$emit('lockName', result);
      break;
    case "unlockName":
      Bus.$emit('unlockName', result);
      break;
    case "moveParticipants":
      Bus.$emit('moveParticipants', result);
      break;
    case "setCopyButton":
      Bus.$emit('setCopyButton', result);
      break;
    case "cancelCopyButton":
      Bus.$emit('cancelCopyButton', result);
      break;
    case "button":
      Bus.$emit('setLoginScreenButton', result);
      break;
    case "setFreeTalk":
      Bus.$emit('setFreeTalk', result);
      break;
    case "cancelFreeTalk":
      Bus.$emit('cancelFreeTalk', result);
      break;
    case "setPrivateTextChat":
      Bus.$emit('setPrivateTextChat', result);
      break;
    case "cancelPrivateTextChat":
      Bus.$emit('cancelPrivateTextChat', result);
      break;
    case "setPublicTextChat":
      Bus.$emit('setPublicTextChat', result);
      break;
    case "cancelPublicTextChat":
      Bus.$emit('cancelPublicTextChat', result);
      break;
    case "partyOnlineStatus":
      Bus.$emit('partyOnlineStatus', result);
      break;
    case "setBackground":
      Bus.$emit('setBackground', result);
      break;
    case "setLogos":
      Bus.$emit('setLogos', result);
      break;
    case "viewPosition":
      Bus.$emit('viewPosition', result);
      break;
    case "setCompanyLogo":
      Bus.$emit('setCompanyLogo', result);
      break;
    case "cancelCompanyLogo":
      Bus.$emit('cancelCompanyLogo', result);
      break;
    case "viewPositionV2":
      Bus.$emit('viewPositionV2', result);
      break;
    case "controlBehavior":
      Bus.$emit('controlBehavior', result);
      break;
    case "responseControlBehavior":
      Bus.$emit('responseControlBehavior', result);
      break;
    case "collaborateInvite":
      Bus.$emit('collaborateInvite', result);
      break;
    case "audioOn":
      Bus.$emit('audioOn', result);
      break;
    case "audioOff":
      Bus.$emit('audioOff', result);
      break;
    case "talkOn":
      Bus.$emit('talkOn', result);
      break;
    case 'talkOff':
      Bus.$emit('talkOff', result);
      break;
    case "audioMatrix":
      Bus.$emit('audioMatrix', result);
      break;
    case "deleteCollaborateInvite":
      Bus.$emit('deleteCollaborateInvite', result);
      break;
    case "fullScreenFromGlobalControl":
      Bus.$emit('fullScreenFromGlobalControl', result);
      break;
    case "startPushStreamFromGlobalControl":
      Bus.$emit('startPushStreamFromGlobalControl', result);
      break;
    case "stopPushStreamFromGlobalControl":
      Bus.$emit('stopPushStreamFromGlobalControl', result);
      break;
    case "muteFromGlobalControl":
      Bus.$emit('muteFromGlobalControl', result);
      break;
    case "addToGlobalControl":
      Bus.$emit('addToGlobalControl', result);
      break;
    case "removeFromGlobalControl":
      Bus.$emit('removeFromGlobalControl', result);
      break;
    case "applyStreamForAll":
      Bus.$emit('applyStreamForAll', result);
      break;
    case "stopPullStream":
      Bus.$emit('stopPullStream', result);
      break;
    case "shareScreenSetting":
      Bus.$emit('shareScreenSetting', result);
      break;
    case "setVoiceCommandProduction":
      Bus.$emit('setVoiceCommandProduction', result);
      break;
    case "pushToTalk":
      Bus.$emit('pushToTalk', result);
      break;
    case "intercom":
      Bus.$emit('intercom', result);
      break;
    case "intercomPro":
      Bus.$emit('intercomPro', result);
      break;
    case "unbindStation":
      Bus.$emit('unbindStation', result);
      break;
    case "leaveParty":
      Bus.$emit('leaveParty', result);
      break;
    case "startVoIP":
      Bus.$emit('startVoIP', result);
      break;
    case "stopVoIP":
      Bus.$emit('stopVoIP', result);
      break;
  }
}
const errorCallback = {
  "800213": () => {}
};
const options = {
  message,
  errorCallback
};
function createWs(url) {
  var ws = Socket(url, options);
  return ws;
}
function GMTtoUTC() {
  let d = new Date();
  let year = d.getUTCFullYear();
  let month = d.getUTCMonth() + 1 < 10 ? `0${d.getUTCMonth() + 1}` : d.getUTCMonth() + 1;
  let date = d.getUTCDate() < 10 ? `0${d.getUTCDate()}` : d.getUTCDate();
  let hours = d.getUTCHours() < 10 ? `0${d.getUTCHours()}` : d.getUTCHours();
  let mins = d.getUTCMinutes() < 10 ? `0${d.getUTCMinutes()}` : d.getUTCMinutes();
  let seconds = d.getUTCSeconds() < 10 ? `0${d.getUTCSeconds()}` : d.getUTCSeconds();
  return `${year}-${month}-${date}T${hours}:${mins}:${seconds}Z`;
}
// 检查并移除字符串partyCode中的重复部分
export function removeDuplicateSegments(value, length) {
  if (!value || value.length !== length) return value;
  const segmentLength = length / 2;
  const firstPart = value.substring(0, segmentLength);
  const secondPart = value.substring(segmentLength);

  // 如果前后两段一样，则只保留前一段
  if (firstPart === secondPart) {
    return firstPart;
  }
  return value;
}
export function getRandomColor(nickName) {
  const colors = ['#EC7850', '#B44141', '#AF52DE', '#5250EC', '#03897B'];
  const hash = djb2Hash(nickName);
  const colorIndex = hash % colors.length;
  return colors[colorIndex];
}
export function djb2Hash(str) {
  if (!str) return;
  let hash = 5381;
  for (let i = 0; i < str.length; i++) {
    hash = (hash << 5) + hash + str.charCodeAt(i); // hash * 33 + c
  }

  return hash >>> 0; // 转换为无符号32位整数
}

const judgeVerticalScreen = function () {
  const width = document.body.clientWidth;
  const height = document.body.clientHeight;
  if (width / height < 1) {
    $store.state.isVertical = true;
    return true;
  } else {
    $store.state.isVertical = false;
    return false;
  }
};
const dynamicLoadJs = function (url, callback, id) {
  var head = document.getElementsByTagName("body")[0];
  var script = document.createElement("script");
  script.type = "text/javascript";
  script.id = id || "";
  script.src = url;
  if (typeof callback == "function") {
    script.onerror = () => {
      callback && callback("failed");
    };
    script.onload = () => {
      if (!this.readyState || this.readyState === "loaded" || this.readyState === "complete") {
        callback && callback("true");
        script.onload = script.onreadystatechange = null;
      }
    };
  }
  head.appendChild(script);
};
const setTagCookie = (tagKey, tagValue, exdays) => {
  var d = new Date();
  d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
  var expires = d.toUTCString();
  let domain = document.domain.split('.');
  domain = `${domain[1]}.${domain[2]}`;
  if (tagKey && tagValue) {
    //字符串拼接cookie
    window.document.cookie = tagKey + "=" + tagValue + ";path=/;domain=" + domain + ";expires=" + expires;
  }
};
export function handleLocalStorage(action, key, value) {
  // 检查浏览器是否支持 localStorage
  try {
    if (typeof localStorage !== 'undefined') {
      // 根据 action 判断是设置还是获取数据
      if (action === 'set' && key !== undefined && value !== undefined) {
        var _localStorage;
        // 检查 value 是否已经是字符串，如果不是，则转换为字符串
        let stringValue = typeof value === 'string' ? value : JSON.stringify(value);
        // 设置 localStorage 的值
        (_localStorage = localStorage) === null || _localStorage === void 0 ? void 0 : _localStorage.setItem(key, stringValue);
      } else if (action === 'get' && key !== undefined) {
        // 获取指定 key 的 localStorage 值
        return localStorage.getItem(key);
      } else if (action === 'remove' && key !== undefined) {
        localStorage.removeItem(key);
      } else {
        // 参数不足或 action 不符合要求
        console.error("Invalid arguments or action.");
        return null;
      }
    } else {
      // 浏览器不支持 localStorage
      console.error("LocalStorage is not supported by this browser.");
      return null;
    }
  } catch (e) {
    return false;
  }
}
const removeHostLoginInfo = function () {
  if (!$store.state.hasLogin && sessionStorage.getItem('isHost')) {
    // 清除之前与会者以host的身份登录的登录信息，
    localStorage.removeItem('memberId');
    localStorage.removeItem('rtilCode');
    sessionStorage.removeItem('isHost');
  }
};
function timestampToTime(timestamp) {
  const date = new Date(timestamp);
  const Y = date.getFullYear() + '-';
  const M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
  const D = date.getDate() + ' ';
  return Y + M + D;
}
function useEventListener(target, event, callback) {
  onMounted(() => target.addEventListener(event, callback));
  onUnmounted(() => target.removeEventListener(event, callback));
}
export function useMove(callback) {
  const x = ref(0);
  const y = ref(0);
  useEventListener(window, 'mousemove', event => {
    x.value = event.pageX;
    y.value = event.pageY;
    const element = event.target;
    if (element) {
      const screenWidth = window.screen.width;
      const screenHeight = window.screen.height;
      sendPosition({
        x,
        y,
        screenWidth,
        screenHeight
      });
    }
  });
  return callback({
    x,
    y
  });
}
function sendPosition({
  x,
  y,
  screenWidth,
  screenHeight
}) {
  const params = {
    partyCode: '746933411446',
    module: 'notify',
    msg: {
      key: 'mousePosition',
      position: {
        x: x.value,
        y: y.value
      },
      email: $store.state.loginInfo.email,
      id: $store.state.loginInfo.id,
      screenWidth,
      screenHeight
    }
  };
  axios.post('/partyline-backend/party/noLogin/command?key=95582', params).then(async res => {});
}
export function addTabTitle(info) {
  const {
    userInfo,
    useTime
  } = info;
  if (!userInfo) return;
  let name = '';
  if (userInfo.title || userInfo.partyName) {
    name = userInfo.title || userInfo.partyName;
  } else {
    if (useTime) {
      name = new Date(userInfo.startPartyTime || userInfo.createTime).toLocaleDateString() + '   ' + new Date(userInfo.startPartyTime || userInfo.createTime).toLocaleTimeString();
    } else {
      name = returnStrByInfo(userInfo.joinCode, userInfo.joinCode.length === 9 ? 3 : 4);
    }
  }
  document.title = i18n.t('common.partyTitle', {
    name
  });
}

// 每几位中间加个字符
export const returnStrByInfo = function (currentStr, lengths = 4, addStr = ' ') {
  if (currentStr && typeof currentStr === 'number') {
    currentStr = String(currentStr);
  }
  if (!currentStr || typeof currentStr !== 'string') return;
  const array = currentStr.split('');
  let _str = '';
  array.forEach((v, i) => {
    if ((i + 1) % lengths === 0 && i != 0) {
      _str += v + addStr;
    } else {
      _str += v;
    }
  });
  return _str;
};
export const FormatTime = (_date, _pattern, text) => {
  if (!_date) return text || '';
  _pattern = _pattern || 'YYYY-MM-DD HH:mm:ss';
  return moment(_date * 1).format(_pattern);
};
export function replaceDuplicateKey(key, str) {
  // 使用正则表达式匹配关键词，忽略大小写，并设置全局搜索标志
  const pattern = new RegExp(key, 'gi');
  let isRepeat = false;
  let isFirstOccurrence = true; // 用于标记是否为第一次出现
  const strVal = str.replace(pattern, match => {
    if (isFirstOccurrence) {
      // 如果是第一次出现，则保留该关键词，不做替换
      isFirstOccurrence = false; // 更新标记
      return match;
    } else {
      isRepeat = true;
      // 从第二次出现开始，替换为为空字符串
      return '';
    }
  });
  return {
    val: isRepeat,
    strVal
  };
}
export function returnSourceType(item, sessionType) {
  let type = 'Web';
  if (!item) return type;
  const {
    deviceType,
    accountId,
    originMemberId
  } = item;
  if (sessionType === 'talent') {
    type = 'Talent';
  } else if (deviceType === 'R') {
    type = 'R';
  } else if (deviceType === 'T') {
    if (Number(item.devicePlatform) >= 10 && Number(item.devicePlatform) <= 14) {
      type = 'Anywhere';
    } else {
      type = 'T';
    }
  } else if (accountId.includes('partylineapp')) {
    type = 'App';
  } else if (originMemberId && originMemberId.startsWith('mediahubdocker_')) {
    type = 'MH';
  }
  return type;
}
export function getFullscreenEnabled() {
  return document.fullscreenEnabled || document.webkitFullscreenEnabled || document.mozFullScreenEnabled || document.msFullscreenEnabled || false;
}
export function generateUniqueId() {
  const timestamp = Date.now().toString(16); // 当前时间戳（16进制）
  const randomPart = [...Array(24)].map(() => Math.floor(Math.random() * 16).toString(16)).join('');
  return timestamp + randomPart;
}
export function routerJump(name, params) {
  const {
    type,
    id,
    passWord,
    join_id,
    model,
    moveParticipants,
    asParticipants,
    number,
    partyCode,
    slotNum,
    env
  } = params || {};
  Router.push({
    name,
    query: {
      id,
      env,
      type,
      model,
      number,
      join_id,
      partyCode,
      moveParticipants,
      asParticipants,
      slotNum
    },
    params: {
      passWord
    }
  });
}
export function userBgColor(email) {
  if (!email) return 'green';
  return $store.state.userColor[email.length % 5];
}

//将选择器与父元素匹配
export function matchesSelectorToParentElements(el, selector, baseNode) {
  let node = el;
  const matchesSelectorFunc = ['matches', 'webkitMatchesSelector', 'mozMatchesSelector', 'msMatchesSelector', 'oMatchesSelector'].find(func => isFunction(node[func]));
  if (!isFunction(node[matchesSelectorFunc])) return false;
  do {
    if (node[matchesSelectorFunc](selector)) return true;
    if (node === baseNode) return false;
    node = node.parentNode;
  } while (node);
  return false;
}

// 添加事件
export function addEvent(el, event, handler) {
  if (!el) {
    return;
  }
  if (el.attachEvent) {
    el.attachEvent('on' + event, handler);
  } else if (el.addEventListener) {
    el.addEventListener(event, handler, true);
  } else {
    el['on' + event] = handler;
  }
}

// 删除事件
export function removeEvent(el, event, handler) {
  if (!el) {
    return;
  }
  if (el.detachEvent) {
    el.detachEvent('on' + event, handler);
  } else if (el.removeEventListener) {
    el.removeEventListener(event, handler, true);
  } else {
    el['on' + event] = null;
  }
}
export default {
  return32Str,
  createWs,
  GMTtoUTC,
  judgeVerticalScreen,
  spaceListener,
  dynamicLoadJs,
  setTagCookie,
  message,
  removeHostLoginInfo,
  timestampToTime,
  useEventListener,
  handleLocalStorage,
  returnSourceType,
  removeDuplicateSegments,
  getRandomColor,
  routerJump,
  generateUniqueId,
  userBgColor,
  matchesSelectorToParentElements,
  addEvent,
  removeEvent,
  returnStrByInfo,
  FormatTime
};